<template>
  <safe-bank-form
    :init-template="template"
    account-type="bank"
    :submit-action="createBank"
    :success-msg="t('bankCreated')"
    :enable-clear-form="false"
    :clear-form-on-submit="false"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SafeBankForm from './SafeBankForm.vue'
import { AccountTemplate } from '@/models/accounting/AccountTemplate'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-bank',

  components: {
    SafeBankForm
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          bankCreated: 'Bank created successfully'
        },
        ar: {
          bankCreated: 'تم إنشاء البنك بنجاح'
        }
      }
    })

    return { t }
  },

  data() {
    return {
      template: new AccountTemplate()
    }
  },

  methods: {
    async createBank(template: AccountTemplate) {
      try {
        await this.$http.post('accounting/accounts/banks', template)
        return null
      } catch (error) {
        return error
      }
    }
  }
})
</script>
